{
  "queryName": "allOrganisations",
  "queryParam": null,
  "fields": ["id", "name", "homepage", "types", "rorLink"]
}
